import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Category } from 'projects/qcloud-models/category/category.model';
import { User } from 'projects/qcloud-models/user/user.model';
import { AuthService } from 'projects/qcloud-rest-client/src/lib/auth/auth.service';
import { CategoryService } from 'projects/qcloud-rest-client/src/lib/category.service';
import { LocationService } from 'projects/qcloud-rest-client/src/lib/location.service';
import { UserService } from 'projects/qcloud-rest-client/src/lib/user.service';
import { NormalizeCharactersPipe } from '../../../shared/normalize-characters.pipe';
import { ChangesTrackerService } from '../../../shared/changes-tracker.service';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  providers: [NormalizeCharactersPipe]
})
export class UserComponent implements OnInit {

  user: User;
  categories: Category[];
  protected initialCategories: Category[];
  public categoryMultiCtrl: UntypedFormControl;
  isEditForm: boolean;
  formSubmitted: boolean = false;
  serveETickets: boolean;
  servedCategories: string = 'served-categories';
  noSelectedCategories = 'no-selected-categories';

  constructor(private categoryService: CategoryService, public authService: AuthService,
    private userService: UserService, private translate: TranslateService, private toastr: ToastrService,
    private normalizeCharactersPipe: NormalizeCharactersPipe, private route: ActivatedRoute,
    private router: Router, public locationService: LocationService, private changesTracker: ChangesTrackerService) { }

  ngOnInit(): void {
    let userId: string;
    this.serveETickets = this.authService.getServeETicket() == "true";
    this.route.params.subscribe(params => {
      userId = params['id']
    });
    if (userId) {
      this.isEditForm = true;
      this.getUser(userId);
    } else {
      this.isEditForm = false;
      this.initializeUser();
    }
  }

  initializeUser() {
    this.user = new User();
    this.user.locationId = +this.authService.getLocationId();
    this.user.systemId = +this.authService.getSystemId()
    this.user.active = true;
    this.user.categories = [];
    this.setPermissions();
    this.getCategories();
  }

  getUser(userId: string) {
    this.userService.getUser(userId).subscribe(
      user => {
        this.user = user;
        this.getCategories();
      }
    );
  }

  setPermissions() {
    let locationConstraints = this.locationService.getLocationConstraints();
    this.user.hasAccessToConsole = true;
    this.user.hasPermissionToCallingTicketsManually = true;
    this.user.hasPermissionToReserveTickets = locationConstraints.areEnabledTicketsReservations;
    this.user.hasPermissionToConfigureGrafik = locationConstraints.isWorkersScheduleEnabled;
    this.user.hasPermissionToServeETickets = locationConstraints.areETicketsEnabled;
  }

  getCategories() {
    this.categoryService.getCategories((data) => {
      this.categories = data;
      this.initialCategories = new Array<Category>();
      for (let j = 0; j < this.user.categories.length; j++) {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i].id == this.user.categories[j].id) {
            this.initialCategories.push(this.categories[i]);
          }
        }
      }
      this.categoryMultiCtrl = new UntypedFormControl(this.initialCategories);
    },
      () => { }
    );
  }

  onSubmit(categories: Category[]) {
    this.user.categories = categories;
    if (this.isEditForm) {
      this.editUser();
    } else {
      this.addUser();
    }
  }

  addUser() {
    this.userService.addUser(this.user).subscribe(
      res => {
        this.changesTracker.trackChange(res.id.toString(), 'user');
        this.router.navigate(['/users']);
      },
      err => {
        this.formSubmitted = false;
        this.translate.get('user-error').subscribe((res: string) => {
          let error = res;
          this.translate.get('username-taken').subscribe((res: string) => {
            this.toastr.error(res, error);
          });
        });
      }
    );
  }

  editUser() {
    this.userService.editUser(this.user).subscribe(
      res => {
        this.changesTracker.trackChange(this.user.id.toString(), 'user');
        this.router.navigate(['/users']);
      },
      err => {
        this.formSubmitted = false;
        this.translate.get('user-edit-error').subscribe((res: string) => {
          let error = res;
          this.translate.get('username-taken').subscribe((res: string) => {
            this.toastr.error(res, error);
          });
        });
      }
    );
  }

  createUsername() {
    if (!this.user.userName && this.user.firstName && this.user.lastName) {

      this.user.userName = (this.user.firstName[0] + this.user.lastName).toLowerCase();
      this.user.userName = this.normalizeCharactersPipe.transform(this.user.userName);
    }
  }

  resetPassword(userId: string) {
    this.userService.resetPassword(userId).subscribe(res => {
      this.translate.get('reset-password-default').subscribe((result: string) => {
        this.toastr.success(result);
      });
    });
  }

  newBasedOnExisting() {
    this.isEditForm = false;
  }

}
